export default __webpack_public_path__ + "static/media/3t.3c39a406.jpg";